export default "__VITE_ASSET__BBakOuAv__"